import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function v80a1090List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/v80a1090/v80a1090List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function v80a1090Save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/v80a1090/v80a1090Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}



